import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid } from "@mui/material";

import TextFieldComponent from "./TextFieldComponent";

export default function RangeDialog({ formikProps }) {
  var dynamicField = formikProps.values;

  const baseSchema = validationSchema.concat(
    Yup.object().shape({
      [formikProps.values.name]: Yup.object().shape({
        min: Yup.string()
          .required(formikProps.values.rangelabel1 + " is required.")
          .matches(formikProps.values.regex1, formikProps.values.errorMessage),
        max: Yup.string()
          .required(formikProps.values.rangelabel2 + " is required.")
          .matches(formikProps.values.regex2, formikProps.values.errorMessage),
      }),
    })
  );

  return (
    <Grid size={12}>
      <Formik
        initialValues={dynamicField}
        enableReinitialize
        validateOnMount
        validationSchema={baseSchema}
      >
        {(dialogFormikProps) => (
          <Grid container spacing={2}>
            <TextFieldComponent
              formikProps={dialogFormikProps}
              fieldDetails={dialogFormikProps.values}
              disabled={!dialogFormikProps.values.editable}
            />
          </Grid>
        )}
      </Formik>
    </Grid>
  );
}
const validationSchema = Yup.object().shape({});
